export type TDataType = 'principal' | 'interest';

export enum EChartSection {
  Realized = 'Realized',
  Pending = 'Pending',
  Outstanding = 'Outstanding',
  Delayed = 'Delayed',
  Loss = 'Loss',
}
